import React, { useState } from "react";
import { Card, Input, Label, Button, Row, Col } from "reactstrap";

// FE type options
const TYPE_OPTIONS = [
  { value: "grouped", label: "Grouped" },
  { value: "individual", label: "Individual" },
];

// Recursive form component for any level
const LevelForm = ({ data, parentType }) => {
  // Always call hooks at the top level
  const [form, setForm] = React.useState({
    name:
      data.program_name ||
      data.service_name ||
      data.sub_service_name ||
      data.category_name ||
      "",
    description: data.description || "",
    type: data.type || "grouped",
    max_amount: data.max_amount || "",
    total_quantity: data.total_quantity || "",
    total_percentage: data.total_percentage || "",
    valueBenefitType: data.valueBenefitType || "",
    benefitMode: data.benefitMode || "",
  });

  // Only show the form if parentType is 'individual' or if this is the root (no parentType)
  if (parentType && parentType !== "individual") return null;

  // Determine children keys for next level
  const childrenKeys = [
    "services",
    "sub_services",
    "categories",
    "sub_categories",
  ];
  const childKey = childrenKeys.find(
    (key) => Array.isArray(data[key]) && data[key].length > 0
  );

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Card className="p-4 mt-3">
      <h5>{form.name}</h5>
      <Row>
        <Col md={6} className="mb-2">
          <Label>Description</Label>
          <Input
            type="text"
            name="description"
            value={form.description}
            onChange={handleChange}
          />
        </Col>
        <Col md={6} className="mb-2">
          <Label>Type</Label>
          <Input
            type="select"
            name="type"
            value={form.type}
            onChange={handleChange}
          >
            {TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-2">
          <Label>Max Amount</Label>
          <Input
            type="text"
            name="max_amount"
            value={form.max_amount}
            onChange={handleChange}
          />
        </Col>
        <Col md={6} className="mb-2">
          <Label>MB Count</Label>
          <Input
            type="number"
            name="total_quantity"
            value={form.total_quantity}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-2">
          <Label>Benefit Mode</Label>
          <Input
            type="select"
            name="benefitMode"
            value={form.benefitMode}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {benefitModeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row>
        {" "}
        {form.benefitMode === "value" && (
          <>
            <Col md={6} className="mb-2">
              <Label>Value Benefit Type</Label>
              <Input
                type="select"
                name="valueBenefitType"
                value={form.valueBenefitType}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="percentage">Percentage</option>
                <option value="flat">Flat</option>
              </Input>
            </Col>
            <Col md={6} className="mb-2">
              <Label>Amount/Percentage</Label>
              <Input
                type="number"
                name="total_percentage"
                value={form.total_percentage}
                onChange={handleChange}
              />
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col md={6} className="mb-2">
          <Label>Rollback Type</Label>
          <Input
            type="select"
            name="rollbackType"
            value={form.rollbackType}
            onChange={handleChange}
          >
            {rollbackTypeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>
        </Col>
        <Col md={6} className="mb-2">
          <Label>Rollback Time</Label>
          <Input
            type="select"
            name="rollbackTime"
            value={form.rollbackTime}
            onChange={handleChange}
          >
            {rollbackTimeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      {/* Render children recursively if present and parent is individual */}
      {childKey &&
        data[childKey].map((child, idx) => (
          <LevelForm key={idx} data={child} parentType={form.type} />
        ))}
      <div className="mt-2 d-flex justify-content-end">
        <Button color="primary">Save</Button>
      </div>
    </Card>
  );
};

const MemberBenefits = ({ programDetails }) => {
  // programDetails is expected to be an array or object with services
  const programs = Array.isArray(programDetails)
    ? programDetails
    : programDetails?.services || [];
  return (
    <div>
      {programs.map((program, idx) => (
        <LevelForm key={idx} data={program} />
      ))}
    </div>
  );
};

export default MemberBenefits;

const rollbackTypeOptions = [
  { value: "registration", label: "Registration" },
  { value: "login_time", label: "Login Time" },
  { value: "financial_year", label: "Financial Year" },
];
const rollbackTimeOptions = [
  { value: "1_month", label: "1 Month" },
  { value: "2_month", label: "2 Month" },
  { value: "3_month", label: "3 Month" },
  { value: "12_month", label: "12 Month" },
];

const benefitModeOptions = [
  { value: "complementary", label: "Complimentary" },
  { value: "value", label: "Value" },
];
